import { CapacitorHttp, HttpOptions, HttpResponse } from "@capacitor/core";
import baseHttpOptions from "../../util/http-common";

const getMaterials = async () => {
    const options: HttpOptions = baseHttpOptions("materiallist");
    const response: HttpResponse = await CapacitorHttp.get(options);
    const { data } = response;
    //console.log(JSON.parse(data))
    return JSON.parse(data);
}

const MaterialService = {
    getMaterials
}

export default MaterialService;